module.exports = "/_next/static/images/cabs-5399e94125e50fa21330ecac77a4b4ef.webp";